import { render } from "./ProcessingList.vue?vue&type=template&id=2270f8e6&scoped=true&ts=true&lang=pug"
import script from "./ProcessingList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProcessingList.vue?vue&type=script&lang=ts&setup=true"

import "./ProcessingList.vue?vue&type=style&index=0&id=2270f8e6&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2270f8e6"]])

export default __exports__